<script lang="ts">
	import type { EnergyTariffBonus } from 'src/types/EnergyTariff';
	import { Text } from '@Shelly/shelly-design-system';

	export let bonuses: EnergyTariffBonus[];
	export let variant: 'light' | 'dark' = 'light';
</script>

{#if bonuses && bonuses.length > 0}
	<div
		class="tariff-bonuses"
		class:variant-light={variant === 'light'}
		class:variant-dark={variant === 'dark'}
	>
		{#each bonuses as bonus}
			<Text styleType="body-small" class="bonus-item">
				including {bonus.description}
			</Text>
		{/each}
	</div>
{/if}

<style>
	.tariff-bonuses {
		display: flex;
		flex-direction: column;
		gap: 1px;
		margin-top: 2px;
	}

	.bonus-item {
		color: #10b981;
		font-size: 10px;
		line-height: 1.2;
		margin: 0;
		font-weight: 500;
	}

	.tariff-bonuses.variant-light .bonus-item {
		color: rgba(16, 185, 129, 0.95);
	}

	.tariff-bonuses.variant-dark .bonus-item {
		color: #10b981;
	}
</style>
